import React from 'react'

interface TabPanelProps {
    children?: React.ReactNode
    index: number
    value: number
    style?: React.CSSProperties
}

const TabPanel: React.FC<TabPanelProps> = ({ children, value, index, style, ...other }: TabPanelProps) => {
    return (
        <div hidden={value !== index} style={style} {...other}>
            {value === index && <>{children}</>}
        </div>
    )
}

export default TabPanel
